const defaultPlatformList = [
    {
        source: 'tb',
        name: '淘宝'
    },
    {
        source: 'tm',
        name: '天猫'
    },
    {
        source: 'tjb',
        name: '淘宝'
    },
    {
        source: 'jd',
        name: '京东'
    },
    {
        source: 'jd_vc',
        name: '京东自营'
    },
    {
        source: '1688',
        name: '1688'
    },
    {
        source: 'wm',
        name: '微盟'
    },
    {
        source: 'weimeng',
        name: '微商城'
    },
    {
        source: 'weimobir',
        name: '智慧零售'
    },
    {
        source: 'mls',
        name: '美丽说'
    },
    {
        source: 'fx',
        name: '天猫分销平台'
    },
    {
        source: 'mgj',
        name: '蘑菇街'
    },
    {
        source: 'sn',
        name: '苏宁'
    },
    {
        source: 'yz',
        name: '有赞'
    },
    {
        source: 'z800',
        name: '折800'
    },
    {
        source: 'ccj',
        name: '楚楚街'
    },
    {
        source: 'yhd',
        name: '一号店'
    },
    {
        source: 'vip',
        name: '唯品会'
    },
    {
        source: 'vipjit',
        name: '唯品会jit'
    },
    {
        source: 'hzw',
        name: '孩子王'
    },
    {
        source: 'pdd',
        name: '拼多多'
    },
    {
        source: 'wd',
        name: '微店'
    },
    {
        source: 'bb',
        name: '贝贝'
    },
    {
        source: 'dd',
        name: '当当'
    },
    {
        source: 'jp',
        name: '卷皮'
    },
    {
        source: 'gm',
        name: '国美'
    },
    {
        source: 'jmyp',
        name: '聚美优品'
    },
    {
        source: 'mia',
        name: '蜜芽'
    },
    {
        source: 'md',
        name: '萌店'
    },
    {
        source: 'rrd',
        name: '人人店'
    },
    {
        source: 'kl',
        name: '考拉'
    },
    {
        source: 'kj_wish',
        name: 'Wish'
    },
    {
        source: 'shopee',
        name: 'Shopee'
    },
    {
        source: 'kj_lazada',
        name: 'Lazada'
    },
    {
        source: 'kj_joom',
        name: 'Joom'
    },
    {
        source: 'kj_ebay',
        name: 'ebay'
    },
    {
        source: 'kj_amazon',
        name: 'Amazon'
    },
    {
        source: 'kj_aliexpress',
        name: 'ALiExpress'
    },
    {
        source: 'yj',
        name: '云集'
    },
    {
        source: 'yjpop',
        name: '云集'
    },
    {
        source: 'ydh',
        name: '易订货'
    },
    {
        source: 'dvd',
        name: '大V店'
    },
    {
        source: 'bbtmh',
        name: '贝贝特卖会'
    },
    {
        source: 'fxg',
        name: '放心购'
    },
    {
        source: 'hyk',
        name: '好衣库'
    },
    {
        source: 'hyk2',
        name: '好衣库'
    },
    {
        source: 'xhs',
        name: '小红书'
    },
    {
        source: 'akc',
        name: '爱库存'
    },
    {
        source: 'dlj',
        name: '达令家'
    },
    {
        source: 'gs',
        name: '环球捕手'
    },
    {
        source: 'fenqile',
        name: '分期乐'
    },
    {
        source: 'xmyp',
        name: '小米有品'
    },
    {
        source: 'ysk',
        name: '云森客'
    },
    {
        source: 'mt',
        name: '萌推'
    },
    {
        source: 'kuaishou',
        name: '快手'
    },
    {
        source: 'yuncang',
        name: '云仓'
    },
    {
        source: 'poison',
        name: '云仓'
    },
    {
        source: 'mokuai',
        name: '魔筷星选'
    },
    {
        source: 'alibabac2m',
        name: 'C2M'
    },
    {
        source: 'duodianwulian',
        name: '多典物联'
    },
    {
        source: 'sys',
        name: '其他'
    },
    {
        source: 'dangkou',
        name: '档口'
    },
    {
        source: 'jd_wd',
        name: '京东外单'
    },
    {
        source: 'twcn',
        name: '京东外单'
    },
    {
        source: 'jd_gxpt',
        name: '京东供销平台'
    },
    {
        source: 'tuhu',
        name: '途虎'
    },
    {
        source: 'omall',
        name: '洋葱'
    },
    {
        source: 'hipac',
        name: '海拍客'
    },
    {
        source: 'yhyx',
        name: '云货优选'
    },
    {
        source: 'kml',
        name: '卡美啦'
    },
    {
        source: 'wwxx',
        name: '万物心选'
    },
    {
        source: 'qm',
        name: '千米'
    },
    {
        source: 'thh',
        name: '团好货'
    },
    {
        source: 'shangluhua',
        name: '商陆花'
    },
    {
        source: 'netease',
        name: '网易严选'
    },
    {
        source: 'cljn',
        name: '磁力金牛'
    },
    {
        source: 'qibo',
        name: '启博微分销'
    },
    {
        source: 'jrbt',
        name: '今日爆团'
    },
    {
        source: 'haoshiqi',
        name: '好食期'
    },
    {
        source: 'ymt',
        name: '洋码头'
    },
    {
        source: 'lazada',
        name: 'lazada'
    },
    {
        source: 'tmcs',
        name: '天猫超市'
    },
    {
        source: 'qinsi',
        name: '秦丝'
    },
    {
        source: 'tmgjzy',
        name: '天猫国际'
    },
    {
        source: 'duxd',
        name: '度小店(用户账号)'
    },
    {
        source: 'bilibili',
        name: '会员购'
    },
    {
        source: 'wxxd',
        name: '微信小店'
    },
    {
        source: 'ktt',
        name: '快团团'
    },
    {
        source: 'wooyingshangquan',
        name: '沃赢商圈'
    },
    {
        source: 'smt',
        name: '速卖通'
    },
    {
        source: 'dingxiang',
        name: '丁香平台'
    },
    {
        source: 'alihealth',
        name: '阿里健康'
    },
    {
        source: 'hishop',
        name: '友数'
    },
    {
        source: 'xiaomang',
        name: '小芒电商'
    },
    {
        source: 'fxg_df',
        name: '抖音厂商代发'
    },
    {
        source: 'fanke',
        name: '凡科商城'
    },
    {
        source: '1889',
        name: '1889'
    },
    {
        source: 'yyjk',
        name: '医药健康(闪购)'
    },
    {
        source: 'pajk',
        name: '平安健康'
    },
    {
        source: 'tmyp',
        name: '天猫优品'
    },
    {
        source: 'amazon',
        name: '亚马逊'
    },
    {
        source: 'duxiaodian_tgzh',
        name: '度小店(推广账号)'
    },
    {
        source: 'qimen',
        name: '奇门'
    },
    {
        source: 'amazon',
        name: '亚马逊'
    },
    {
        source: 'open',
        name: '自建平台'
    },
    {
        source: 'alibaba_icbu',
        name: '淘宝'
    },
    {
        source: 'xy',
        name: '闲鱼'
    },
    {
        source: 'pddtemu',
        name: 'Temu'
    },
    {
        source: 'mmw',
        name: '妈妈网'
    }
]

const getPlatfromList = () => {
    if (window.PlatformSourceService) {
        const platformSourceInstance = PlatformSourceService.getInstance();
        const newList = platformSourceInstance.getOriginSource();
        return newList;
    }
    return defaultPlatformList;
}

const adaptKmui = () => {
    // kmui的店铺选择组件中的平台需要获取RayCloud.util.getPlatfromList来拿最新平台数据，供应链暂无此对象方法，需要兼容
    let RayCloud = window.RayCloud || {};
    let util = RayCloud.util || {};
    util.getPlatfromList = getPlatfromList;
    RayCloud.util = util;
    window.RayCloud = window.RC = RayCloud;
}

export default {
    adaptKmui
}